import { useTranslation } from "react-i18next";
import {Consts} from "../../pages/consts";
import {buildInteractionParam} from "../../pages/utils";
import {phenotypeMap} from "../../../resources/json/jsons";
import i18n from "i18next";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faXmark} from "@fortawesome/free-solid-svg-icons";

const Recommendations = ({ risk, setRisk, showDialog, gene }) => {
  const { t } = useTranslation();
  let substance = JSON.parse(risk?.recommendation)[i18n.language?.toUpperCase()]?.substanceName;

  if(substance === ""){
    substance = risk.substanceKey;
  }

  return (
    <div
      className="w3-modal"
      style={{ display: showDialog ? Consts.BLOCK : Consts.NONE }}
    >
      <div className="w3-modal-content w3-animate-zoom form-panel dialog-narrow">
        <header className="dialog-drag-header feedback-modal-header-right">
          <h2>{t("recommendations_of_dpwg")} {t("for")} {gene?.geneName} {gene?.genotype}{" "}
            ({phenotypeMap[gene?.phenotype]}) {t("for")} {substance}</h2>
          <FontAwesomeIcon
            icon={faXmark}
            className="dialog-drag-close"
            onClick={() => setRisk(null)}
          />
        </header>
        <div className="w3-container dialog-content-scroll" style={{textAlign: "left"}}>
          <label className="w3-margin">
            {risk
              ? buildInteractionParam(risk?.recommendation, true)
              : ""}
          </label>
        </div>
      </div>
    </div>
  );
};

export default Recommendations;
